module.exports = __webpack_public_path__ + "static/media/logo.fea31fcf.png";